
import { BasicControl, BlockT, CURSOR_TYPE, ChangeModelCommand, DYMODE_MODE, LineT, Listeners, ModelBase, Plane, Point, RenderMode, SelectionBox, TnEngineContext, TnEngineExtraContext, ViewEditor, dymode } from "pytha"
import { DEVICE_CTRL_TYPE } from "../enums/control-type";
import { Vector2, Vector3 } from "three";
import { DEVICEBASE_SINGAL } from "../enums/devicebase-singal";

const MOUSE = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
}


/**
 * 可直接根据点击点布置块，可连续布置，块需要布置在捕捉点或者图元（从鼠标位置穿透到第一个面上的点作为布置点）上
 */
export class AssembleDeviceControl extends BasicControl {
    id = DEVICE_CTRL_TYPE.SINGLE_ASSEMBLE_DEVICE;

    point_down: Point = new Point();
    point_move: Point = new Point();

    capturePoint: Vector3;

    step: number = 1;

    helpBlock: BlockT = new BlockT();
    blocks: BlockT[];
    helpLine: LineT;

    private _dir = new Vector3();
    private _pointLast = new Point();

    axisX: Vector3;
    axisY: Vector3;
    axisZ: Vector3;

    firstPoint: Vector3 = new Vector3();
    needInit: boolean;
    layerUuid: string; // 块所在的图层uuid
    isColorByLayer: boolean = true;

    context: TnEngineContext;
    extraContext: TnEngineExtraContext;

    angle: number = 0;
    angle_last: number = 0;

    workPlane: Plane = new Plane();
    planeX: Plane = new Plane();
    planeY: Plane = new Plane();
    planeZ: Plane = new Plane();

    offset: number = 0;

    // entityType: number

    axisExist: boolean = false;

    hasInserted: boolean = false;

    pickBox: SelectionBox

    beforeRenderMode: number

    options = {
        0: [
            { name: '退出', key: 'X' },
        ],
    }

    constructor(editor: ViewEditor, listeners: Listeners) {
        super();
        this.needInit = true;
        this.editor = editor;
        this.listeners = listeners;
        this.context = TnEngineContext.getInstance();
        this.extraContext = TnEngineExtraContext.getInstance();
        this.listeners.signals.needCapture.dispatch();
        editor.renderer.domElement.addEventListener('pointermove', this.onPointerMove);
        this.listeners.signals.onDymodeChanged.add(this.onDymodeChanged);
        this.listeners.signals.onPointCapture.add(this.onPointCapture);
        this.listeners.getSignal(DEVICEBASE_SINGAL.onAssembleDevice).add(this.onAssembleDevice);
        this.listeners.signals.onCursorChange.dispatch(CURSOR_TYPE.CROSS);
        this.editor.selectControl.setEnabled(false);
        this.extraContext.dymodeContext.enabled = true;
        this.extraContext.dymodeContext.setMode(DYMODE_MODE.POINT);
        this.listeners.signals.sendToDymodeTip.dispatch('指定基点:');
        this.extraContext.stmodeContext.setStmode('指定基点');
        this.axisX = this.context.ucsContext.getAxisList().axisX.clone();
        this.axisY = this.context.ucsContext.getAxisList().axisY.clone();
        this.axisZ = this.context.ucsContext.getAxisList().axisZ.clone();
        this.workPlane.setFromNormalAndCoplanarPoint(this.context.ucsContext.getAxisList().axisZ, this.context.ucsContext.getAxisList().origin.clone());
        this.pickBox = new SelectionBox(editor.camera)
        this.beforeRenderMode = this.context.renderContext.renderType;
        this.editor.clampControl.enabled = false
        // 默认转换为概念模型
        new ChangeModelCommand(this.editor, RenderMode.CONCEPT).execute();
        console.log('SingleAssembleDeviceControl added');
    }

    dispose(): void {
        this.editor.renderer.domElement.removeEventListener('pointermove', this.onPointerMove);
        this.editor.renderer.domElement.removeEventListener('pointerdown', this.onPointerDown);
        this.listeners.signals.onDymodeChanged.remove(this.onDymodeChanged);
        this.listeners.signals.onPointCapture.remove(this.onPointCapture);
        this.listeners.getSignal(DEVICEBASE_SINGAL.onAssembleDevice).remove(this.onAssembleDevice);
        this.editor.selectControl.setEnabled(true);
        this.editor.clampControl.enabled = true
        if (this.helpLine && this.helpLine.viewObj && this.helpLine.viewObj.parent) {
            this.helpLine.viewObj.parent?.remove(this.helpLine.viewObj);
        }
        if (this.helpBlock && this.helpBlock.viewObj && this.helpBlock.viewObj.parent) {
            this.helpBlock.viewObj.parent?.remove(this.helpBlock.viewObj);
        }
        // 转换为之前的渲染类型
        new ChangeModelCommand(this.editor, this.beforeRenderMode).execute();
        console.log('SingleAssembleDeviceControl removed');
    }

    onPointCapture = (point) => {
        this.capturePoint = point;
    }

    // onAssembleDevice = (block: BlockT, firstPoint: Vector3, layerUuid: string, name = null, group: { key: number, value: string }[] = []) => {
    onAssembleDevice = (block: BlockT, firstPoint: Vector3, layerUuid: string) => {
        if (this.helpBlock && this.helpBlock.viewObj && this.helpBlock.viewObj.parent) {
            this.helpBlock.viewObj.parent?.remove(this.helpBlock.viewObj);
        }
        this.layerUuid = layerUuid;
        this.firstPoint = firstPoint;
        this.isColorByLayer = block.isColorByLayer;

        // 处理数据，将按照基点(0,0,0)
        // let first = new Vector3(0, 0, 0);
        console.log('block.position', block.position)
        let first = new Vector3(block.position.x, block.position.y, block.position.z);
        let second = new Vector3(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);
        let dir = second.clone().sub(first.clone()).normalize();
        let dist = first.distanceTo(second);

        this.editor.renderer.domElement.focus();
        this.helpBlock = block.clone();
        this.helpBlock.extraData = block?.extraData || {};

        this.helpBlock.move(dir, dist);
        this.point_down.set(this.helpBlock.position.x, this.helpBlock.position.y, this.helpBlock.position.z);
        this._pointLast = this.helpBlock.position.clone();
        this.helpBlock.render();
        this.extraContext.sceneContext.scene.add(this.helpBlock.viewObj);
        this.listeners.signals.needRender.dispatch();
        this.editor.renderer.domElement.addEventListener('pointerdown', this.onPointerDown);

        let initData = {
            block: block,
            firstPoint: firstPoint,
            layerUuid: layerUuid,
        }
        this.listeners.signals.setInitControlData.dispatch(initData);
    }

    private firstIn = true;
    onPointerMove = (event) => {
        if (!!!this.helpBlock) {
            return;
        }

        let rect = this.editor.renderer.domElement.getBoundingClientRect();
        let x = (event.clientX - rect.x) / rect.width * 2 - 1;
        let y = -(event.clientY - rect.y) / rect.height * 2 + 1;
        this.context.ucsContext.unprojectCursorPoint(x, y, this.editor.camera, this.point_move, this.workPlane);

        if (this.capturePoint) {
            this.point_move.copy(this.capturePoint);
        }

        if (this.step == 1) {
            this._dir.set(this.point_move.x - this.helpBlock.position.x, this.point_move.y - this.helpBlock.position.y, this.point_move.z - this.helpBlock.position.z);
            if (this.firstIn) {
                this._dir.set(0, 0, 0);
                this.firstIn = false;
            }

            let length = this._dir.length();
            this._dir.normalize();
            this.helpBlock.move(this._dir, length);
            this.helpBlock.updateViewGeometry();
            this._pointLast.copy(this.point_move);
            this.listeners.signals.needRender.dispatch();

        }
    }



    onPointerDown = (event) => {
        if (event.button === MOUSE.RIGHT) {
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
            return;
        }
        if (event.button !== MOUSE.LEFT) return;
        if (!!!this.helpBlock) {
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
        }
        // 有捕捉点，优先捕捉
        if (this.capturePoint) {
            this.point_down.copy(this.capturePoint);
            if (this.step == 1) {
                this.step_1();
            }
            return;
        }

        // 设置选择box
        let rect = this.editor.renderer.domElement.getBoundingClientRect();
        let PickEpsilon = this.extraContext.editStatusContext.PickEpsilon;
        let top_left_x = event.clientX - PickEpsilon;
        let top_left_y = event.clientY - PickEpsilon;
        let bottom_right_x = event.clientX + PickEpsilon;
        let bottom_right_y = event.clientY + PickEpsilon;

        let start_x = (top_left_x - rect.x) / rect.width * 2 - 1;
        let start_y = -(top_left_y - rect.y) / rect.height * 2 + 1;
        let end_x = (bottom_right_x - rect.x) / rect.width * 2 - 1;
        let end_y = -(bottom_right_y - rect.y) / rect.height * 2 + 1;
        this.pickBox.update(new Vector2(start_x, start_y), new Vector2(end_x, end_y))

        // 获取鼠标位置射线在图元上的交点
        let placePoint = this.getPlacePoint();
        if (placePoint != null) {
            this.point_down.set(placePoint.x, placePoint.y, placePoint.z);
            this.step_1();
        } else {
            // 提示没有布置在图元上
            this.extraContext.stmodeContext.pushTip('设备需布置在图元上')
            return
        }
    }


    getPlacePoint = () => {
        let entityDict: { [key: string]: ModelBase } = this.editor.entityDictInViewport;
        let _frustum = this.pickBox._frustum;
        let shortDist = Number.MAX_VALUE

        for (let key in entityDict) {
            let entity = entityDict[key]
            if (!!entity) {
                let dist = entity.rangeShootPick(_frustum)
                if (dist != Number.MAX_VALUE && dist < shortDist) {
                    shortDist = dist
                }
            }
        }
        if (shortDist == Number.MAX_VALUE) return null;
        let cp = new Point(_frustum.ray.origin.x, _frustum.ray.origin.y, _frustum.ray.origin.z);
        let point = cp.move(new Vector3(_frustum.ray.direction.x, _frustum.ray.direction.y, _frustum.ray.direction.z).normalize(), shortDist);
        return point;
    }


    step_1() {
        this._dir.set(this.point_down.x - this._pointLast.x, this.point_down.y - this._pointLast.y, this.point_down.z - this._pointLast.z);
        let length = this._dir.length();
        this._dir.normalize();
        this.helpBlock.move(this._dir, length);
        this.helpBlock.updateViewGeometry();
        this._pointLast.copy(this.point_move);

        this.listeners.signals.needRender.dispatch();
        // 放置
        let layerUuid = this.layerUuid;
        if (!layerUuid) {
            layerUuid = this.context.layerContext.currentLayerUuid;
        }
        let clone = this.helpBlock.clone();
        clone.extraData = this.helpBlock?.extraData || {};
        // let addPris: ModelBase[] = [this.helpBlock.clone()];
        let addPris: ModelBase[] = [clone];
        // 这里发一个布置结束的信号，信号携带参数给侧边栏，侧边栏添加
        this.extraContext.getCurrentViewEditor().listeners.getSignal(DEVICEBASE_SINGAL.onAssembleDeviceFinish).dispatch({ addPris: addPris });
        this.extraContext.getCurrentViewEditor().listeners.signals.onCaptureModeChanged.dispatch();
        // this.listeners.signals.onOpeCommandControlEnd.dispatch();
    }

    onDymodeChanged = (value: dymode) => {
        if (this.step == 1) {
            if (value.mode === DYMODE_MODE.CHOOSE) {
                if (value.choose === 'X') {
                    //退出
                    this.listeners.signals.onOpeCommandControlEnd.dispatch();
                }
            } else if (value.mode === DYMODE_MODE.POINT) {
                this.point_down.set(value.x, value.y, value.z);
                this.step_1();
            }
        }

    }

    initControl(data: any): void {
        if (!!data) {
            this.onAssembleDevice(data.block, data.firstPoint, data.layerUuid);
            // this.extraContext.stmodeContext.pushTip('不可重复布置!');
            // this.listeners.signals.onOpeCommandControlEnd.dispatch();
            // return;
        }
    }

}